import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {AuthComponent} from './auth/auth.component';
import {SignInComponent} from './sign-in/sign-in.component';
import {ProfileCandidateComponent} from './ProfileCandidate/ProfileCandidate.component';
import {MainFeedComponent} from './main-feed/main-feed.component';
import {ProfilComponent} from './profil/profil.component';
import {ElectionComponent} from './election/election.component';

const routes: Routes = [
  { path: '', redirectTo: '/Home', pathMatch: 'full' },
  { path: 'SignUp', component: AuthComponent },
  { path: 'SignIn', component: SignInComponent },
  { path: 'Home', component: HomeComponent },
  { path: 'Details/:id', component: ProfileCandidateComponent },
  { path: 'mainFeed', component: MainFeedComponent },
  { path: 'profil', component: ProfilComponent },
  { path: 'election', component: ElectionComponent }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

